import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTTextArea {
    innerValue = '';

    $onChanges() {
        this.innerValue = angular.copy(this.value);
    }

    valueChange() {
        const value = angular.copy(this.innerValue);

        this.onChange({ value });
    }
}

export const TFTTextAreaConfig = {
    template,
    bindings: {
        value: '<',
        placeholder: '@',
        className: '@',
        onChange: '&',
    },
    controller: TFTTextArea,
    controllerAs: 'tftTextAreaCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftTextArea', TFTTextAreaConfig);